
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#002E6B","stroke":"#002E6B"}},[_c('path',{attrs:{"d":"M2.491.399l14.58 14.634-1.562 1.568L.929 1.967z"}}),_c('path',{attrs:{"d":"M17.07 1.967L2.492 16.6.93 15.033 15.51.4z"}})])])
          )
        }
      }
    